import { render, staticRenderFns } from "./ViewGDPRDocumentConfirmation.vue?vue&type=template&id=f4684986&scoped=true&"
import script from "./ViewGDPRDocumentConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ViewGDPRDocumentConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./ViewGDPRDocumentConfirmation.vue?vue&type=style&index=0&id=f4684986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4684986",
  null
  
)

export default component.exports